 $('.cstm_slide').slick({
   dots: true,
   infinite: false,
   speed: 300,
   slidesToShow: 2,
   slidesToScroll: 1
 });
 $(window).on('resize', function(){
    var win = $(this);
 if($(win).width() <= 767){
   $('.cstm_slide').slick('refresh'); $('.cstm_slide').slick('slickSetOption','slidesToShow', 2);$('.cstm_slider').slick('slickSetOption','slidesToScroll', 1);$('.cstm_slide').slick('slickNext');
  
   }
  if($(win).width() <= 480) {
    $('.cstm_slide').slick('refresh'); $('.cstm_slide').slick('slickSetOption','slidesToShow', 1);$('.cstm_slider').slick('slickSetOption','slidesToScroll', 1);$('.cstm_slide').slick('slickNext');

   
 }
 });

// $('.cstm_slide').slick({
//   dots: true,
//   infinite: false,
//   speed: 300,
//   slidesToShow: 2,
//   slidesToScroll: 1,
//   responsive: [
//     {
//       breakpoint: 768,
//       settings: {
//         slidesToShow: 3,
//         slidesToScroll: 3,
//         infinite: false,
//         dots: false
//       }
//     },
//     {
//       breakpoint: 600,
//       settings: {
//         slidesToShow: 2,
//         slidesToScroll: 2
//       }
//     },
//     {
//       breakpoint: 480,
//       settings: {
//         slidesToShow: 1,
//         slidesToScroll: 1
//       }
//     }

//   ]

// });
$('.cstm_slide').on('afterChange', function(event, slick, currentSlide) {

if (slick.$slides.length-1 == currentSlide) {
$('.slick-next').attr("disabled", true);
} else{
$('.slick-next').attr("disabled", false);
}

if (0 == currentSlide) {
$('.slick-prev').attr("disabled", true);
} else{
$('.slick-prev').attr("disabled", false);
}


})